import produce from "immer";

import { CombinedClientPublicCandidateActionTypes } from "../";
import { ClientPublicCandidateState } from "../clientPublicCandidateState";
import names from "./clientPublicCandidateUIActionTypes";

// follow example of admin candidates
export const publicCandidateUIReducer = (
    state: ClientPublicCandidateState,
    action: CombinedClientPublicCandidateActionTypes
): ClientPublicCandidateState => {
    const newState = produce(state, draft => {
        switch (action.type) {
            case names.SET_SELECTED_LEAD_TAB: {
                draft.ui.selectedCandidateTab = action.payload.tab;
                break;
            }
            case names.CLEAR_ERROR: {
                draft.ui.error = undefined;
                break;
            }
        }
    });
    return newState;
};
